export default "__VITE_ASSET__BgF2M0fU__"